import React from 'react';
import Header from './header'; // Assuming the Header component is in the same directory as App.js
import Landing from './landing';
import Footer from './footer';
import Education from './education';
import Projects from './projects';
import Separator from './separator';
import Pratical from './pratical';
import Tools from './tools';


function Home() {
  return (
    <div>
        <Landing/>
        <Projects/>
        <Tools/>
        <Separator/>
        <Pratical/>
        <Education/>

    </div>
  );
}

export default Home;
